export const DOCUMENT_EXPORT_APPROVAL_PATH = "/exports/approve";

export function createDocumentExportApprovalId(
  subjectType,
  subjectId,
  artifactVersion,
  contentHash,
  analysisRunId = null
) {
  return `${subjectType}#${subjectId}#${artifactVersion}#${String(contentHash || "").toLowerCase()}#${analysisRunId || "none"}`;
}

export function isDocumentExportApproved(approval, {
  subjectType,
  subjectId,
  artifactVersion,
  contentHash,
  analysisRunId = null,
}) {
  return Boolean(
    approval?.status === "APPROVED_FOR_EXPORT" &&
    approval.subjectType === subjectType &&
    approval.subjectId === subjectId &&
    Number(approval.artifactVersion) === Number(artifactVersion) &&
    approval.contentHash === String(contentHash || "").toLowerCase() &&
    (subjectType !== "IDR_CASE" || approval.analysisRunId === analysisRunId)
  );
}

export async function hashExportContent(value) {
  if (!window.crypto?.subtle) {
    throw new Error("This browser cannot verify export approval. Use a current browser over HTTPS.");
  }
  const digest = await window.crypto.subtle.digest(
    "SHA-256",
    new TextEncoder().encode(String(value || ""))
  );
  return Array.from(new Uint8Array(digest), (byte) => byte.toString(16).padStart(2, "0")).join("");
}
